export default __webpack_public_path__ + "static/media/audio_26_banda_de_musicos.89afdbc5.mp3";